"use client";

import React, { useState } from "react";
import Image from "next/image";
import { Box } from "@mui/material";
import PageHeadDataFetcher from "../ApplicationDataFetcher";

const LogoContainer2 = () => {
  const [appData, setAppData] = useState<any>(null);

  return (
    <>
      <PageHeadDataFetcher setApplicationData={setAppData} />
      <Box
        sx={{
          // mb: 4,
          width: "200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {appData?.logo ? (
          <Box
            sx={{
              width: 130,
              height: 130,
              marginBottom: 4,
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "#fff",
              backgroundColor: "transparent",
              // backgroundColor: "#fff", // required for shadow visibility
              boxShadow: "0 12px 30px rgba(0, 0, 0, 0.18)",
            }}
          >
            <Image
              className="w-full h-full object-cover"
              src={appData?.logo}
              alt="MSA Logo"
              width={80}
              height={45}
            />
          </Box>
        ) : (
          <Box sx={{ width: "200px" }}>
            <Image
              src="/assets/images/MSAWHITELOGO.svg"
              alt="MSA Logo"
              width={200}
              height={80}
              className="max-h-[200px] min-h-[200px] min-w-[200px]"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default LogoContainer2;
